import React from "react";

const Section = ({
  children,
  direction = "column",
  accentColor = false,
  fillScreen = false,
  id,
  ...props
}: SectionProps) => {
  return (
    <div
      {...props}
      id={id}
      className={`w-full flex gap-6 px-20 py-6 items-center justify-center max-lg:px-10 max-md:px-1 max-md:py-1 ${
        direction === "column" ? "flex-col" : "flex-row"
      }
      ${accentColor ? "bg-accent" : ""}
      ${fillScreen ? "min-h-screen" : ""}
      `}
    >
      <div
        className={`${
          props?.className || ""
        } flex flex-col items-center justify-start w-full max-w-screen-2xl`}
      >
        {children}
      </div>
    </div>
  );
};

interface SectionProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children?: React.ReactNode;
  direction?: "column" | "row";
  accentColor?: boolean;
  id?: string;
  fillScreen?: boolean;
}
export default Section;
